import { __assign } from "tslib";
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { colors } from '../../theme';
import { Typography } from './Typography';
import { Button } from './Button';
export var DeletionModal = function (_a) {
    var title = _a.title, message = _a.message, onClickCancel = _a.onClickCancel, onClickDelete = _a.onClickDelete, _b = _a.width, width = _b === void 0 ? '584px' : _b, _c = _a.height, height = _c === void 0 ? 'auto' : _c, style = _a.style;
    return (React.createElement("div", { style: __assign({ width: width, minWidth: '300px', height: height, minHeight: '200px', paddingTop: '31px', paddingRight: '31px', paddingBottom: '24px', paddingLeft: '31px', display: 'flex', flexDirection: 'column', gap: '16px', backgroundColor: colors.white, borderRadius: '8px', boxShadow: '0px 2px 4px rgba(34, 41, 69, 0.37)' }, style) },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
            } },
            React.createElement(FontAwesomeIcon, { icon: faTriangleExclamation, color: colors.yellow[50], style: {
                    backgroundColor: 'rgba(216, 160, 50, 0.1)',
                    borderRadius: '100%',
                    padding: '6px'
                } }),
            React.createElement(Typography, { variant: 'h4-medium', style: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%'
                } }, title)),
        React.createElement("div", { style: {
                paddingLeft: '40px'
            } },
            React.createElement(Typography, { variant: 'body-regular' }, message)),
        React.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '16px',
                marginTop: '32px'
            } },
            React.createElement(Button, { size: "sm", variant: "gray", onClick: onClickCancel, style: {
                    paddingLeft: '18px',
                    paddingRight: '18px'
                } }, "Cancel"),
            React.createElement(Button, { size: "sm", variant: "grayRed", onClick: onClickDelete, style: {
                    paddingLeft: '24px',
                    paddingRight: '24px'
                } }, "Delete"))));
};
